// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"23f81217","732":"dd7889c4","977":"278dcda2"}[chunkId] + ".chunk.js";
};